import { c as _c } from "react/compiler-runtime";
import { FormInput, PaymentProcessorEnum, PrimaryButton, getPaymentProcessorTitle } from '@systemeio/ui';
import HelpCenterLink from 'modules/profile/payment-gateways/components/help-center-link';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { flutterwaveConnect } from 'modules/profile/payment-gateways/integrations/flutterwave/api';
import { PaymentFlutterwaveInterface } from 'modules/profile/payment-gateways/integrations/flutterwave/types';
import { getFlutterwaveHelpPageLink } from 'modules/profile/payment-gateways/integrations/flutterwave/utils';
import React, { useState } from 'react';
import CreateModal from 'shared/components/create-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
interface FlutterwaveCreateModalProps {}
const defaultValues: PaymentFlutterwaveInterface = {
  apiEncryptionKey: '',
  apiKeySecret: '',
  apiPublicKey: ''
};
const defaultErrors: PaymentFlutterwaveInterface = {
  apiEncryptionKey: '',
  apiPublicKey: '',
  apiKeySecret: ''
};
const FlutterwaveCreateModal = t0 => {
  const $ = _c(38);
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const [opened, setOpened] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  const {
    mutatePaymentIntegrations
  } = useConnectedPaymentIntegrations();
  let t1;
  if ($[0] !== mutatePaymentIntegrations) {
    t1 = async data => {
      await fetchWithErrors(async () => {
        await flutterwaveConnect(data);
        await mutatePaymentIntegrations();
      }, setErrors);
    };
    $[0] = mutatePaymentIntegrations;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onCreate = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e => {
      e.preventDefault();
      setOpened(true);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("dashboard.settings.payment_gateways.connect");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <PrimaryButton onClick={t2} className="font-bold">{t3}</PrimaryButton>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t("dashboard.settings.payment_gateways.connect_payment_title", {
      payment: getPaymentProcessorTitle(PaymentProcessorEnum.Flutterwave)
    });
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setOpened(false);
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== errors || $[11] !== t) {
    t7 = {
      field: "apiPublicKey",
      onRender: (value, onChange) => <FormInput key="flutterwave-apiPublicKey-create" label={t("dashboard.settings.payment-gateways.api_public_key")} value={value} onChange={e_0 => onChange(e_0.target.value)} error={errors.apiPublicKey} />
    };
    $[10] = errors;
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== errors || $[14] !== t) {
    t8 = {
      field: "apiKeySecret",
      onRender: (value_0, onChange_0) => <FormInput key="flutterwave-apiKeySecret-create" label={t("dashboard.settings.payment-gateways.api_secret_key")} value={value_0} onChange={e_1 => onChange_0(e_1.target.value)} error={errors.apiKeySecret} />
    };
    $[13] = errors;
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== errors || $[17] !== t) {
    t9 = {
      field: "apiEncryptionKey",
      onRender: (value_1, onChange_1) => <FormInput key="flutterwave-apiEncryptionKey-create" label={t("dashboard.settings.payment-gateways.api_encryption_key")} value={value_1} onChange={e_2 => onChange_1(e_2.target.value)} error={errors.apiEncryptionKey} />
    };
    $[16] = errors;
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t10 = [t7, t8, t9];
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const t11 = user?.dashboardLocale;
  let t12;
  if ($[23] !== t11) {
    t12 = getFlutterwaveHelpPageLink(t11);
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = getPaymentProcessorTitle(PaymentProcessorEnum.Flutterwave);
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t12) {
    t14 = <HelpCenterLink link={t12} integration={t13} />;
    $[26] = t12;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = ["apiEncryptionKey", "apiKeySecret", "apiPublicKey"];
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== onCreate || $[30] !== opened || $[31] !== t10 || $[32] !== t14 || $[33] !== t5) {
    t16 = <CreateModal fullCaption={t5} opened={opened} onClose={t6} defaultValues={defaultValues} needToast={false} creatable={t10} additionalInfo={t14} onCreate={onCreate} requiredFields={t15} />;
    $[29] = onCreate;
    $[30] = opened;
    $[31] = t10;
    $[32] = t14;
    $[33] = t5;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t16 || $[36] !== t4) {
    t17 = <>{t4}{t16}</>;
    $[35] = t16;
    $[36] = t4;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  return t17;
};
export default FlutterwaveCreateModal;